export const lineStatusWithImages = [
  {
    value: 'All states',
    label: 'All states',
    image: '',
  },
  {
    value: 'draft',
    label: 'Draft',
    image: 'status/draft.svg',
  },
  {
    value: 'submitted',
    label: 'Submitted',
    image: 'status/submitted.svg',
  },
  {
    value: 'pending',
    label: 'Pending',
    image: 'status/pending.svg',
  },
  {
    value: 'active',
    label: 'Active',
    image: 'status/active.svg',
  },
  {
    value: 'complete',
    label: 'Complete',
    image: 'status/complete.svg',
  },
];

export function getStatusColor(theme, status) {
  switch (status) {
    case 'All states':
      return theme.palette.brand.greyDark;
    case 'inactive':
      return theme.palette.brand.greyDark;
    case 'draft':
      return theme.palette.brand.pinkLight;
    case 'submitted':
      return theme.palette.brand.greyMid;
    case 'pending':
      return theme.palette.brand.pinkLight;
    case 'complete':
      return theme.palette.brand.greyMid;
    case 'active':
      return theme.palette.brand.mint;
    case 'achEnabled':
      return theme.palette.brand.greenLight;
    case 'verified':
      return theme.palette.brand.greenLight;
    case 'connected':
      return theme.palette.primary.main;
    case 'reconnect':
      return theme.palette.brand.greenDark;
    case 'notConnected':
      return theme.palette.brand.greenNature;
    case 'attentionRequired':
      return theme.palette.brand.orangeDark;
    case 'notVerified':
      return theme.palette.brand.pink;
    case 'sellingGood':
      return theme.palette.brand.greyMid;
    case 'sellingBad':
      return theme.palette.brand.yellowAlert;
    case 'changeRequest':
      return theme.palette.brand.yellowAlert;
    case 'hasTip':
      return theme.palette.brand.yellowAlert;
    default:
      return theme.palette.grey[400];
  }
}

export const statusIconBlackList = ['All states'];
